import type { ChangeEvent, ReactNode, RefObject } from "react";
// import { SignatureModal } from "../../../components/Form/SignatureModel";
// import { AttachmentSection } from "../../../components/Form/AttachmentSection";
import type { LegalAdviceFormSixData } from "../../../types/LegalAdvices/LegalAdviceFormSix.type";
import { DatalistInput } from "../components/dataListInput";
// import { FormActionButtons } from "../../../components/Form/FormActionButton";
import { useSettings } from "../../../context/SettingContext";


export interface AttachmentFile {
  name: string;
  [key: string]: any;
}

export interface DetailFormDocumentProps {
  formData: LegalAdviceFormSixData;
  isEditable: boolean;
  isSigning: boolean;
  sigCanvasRef: RefObject<any>;
  setIsSigning: (isSigning: boolean) => void;
  handleChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSaveSignature: () => void;
  renderDocumentRow: (label: string, fieldName: any) => ReactNode;
  renderDatePicker: (fieldName: any) => ReactNode;

  // Additional props required for action controls inside this component
  isPreview?: boolean;
  // isSubmitting?: boolean;
  // isApproved?: boolean;
  handleBackNavigation: () => void;
  // handleSaveDraft: (e: React.MouseEvent) => void;
  // handleSubmitToSuperior: (e: React.MouseEvent) => void;
 // handleAttachment:(e:React.MouseEvent)=> void;
}

export const LegalDetailFormSixDocument: React.FC<DetailFormDocumentProps> = ({
  formData,
//   isSigning,
//   sigCanvasRef,
  setIsSigning,
  handleChange,
//   handleSaveSignature,
  renderDatePicker,
  // isApproved,
  // isSubmitting = false,
  // handleBackNavigation,
  // handleSaveDraft,
  // handleSubmitToSuperior,
  // handleAttachment
}) => {
  // Replace these with your actual option data sources or imports
 const { settings } = useSettings();

//  const isFormSigned = Boolean(
//     formData.signatureImage?.trim() && 
//     (formData.signerName?.trim() || formData.signName?.trim())
//   );

// Map to simple string arrays for your dropdowns/datalists
const OFFICE_OPTIONS = settings?.offices.map((o) => o.name) || [];
const TOWNSHIP_OPTIONS = settings?.townships.map((t) => t.name) || [];


  return (
    <div className="w-full max-w-[800px] bg-white shadow-lg border border-gray-300 p-12 text-black leading-relaxed relative text-sm md:text-base">
            <div className="absolute top-4 right-4 text-xs font-bold">ဥပရအမှုလိုက်ပုံစံ (၆)</div>
    
            {/* Header Section */}
            <div className="text-center space-y-2 mt-4">
              <h1 className="text-lg font-bold">ပြည်ထောင်စုသမ္မတမြန်မာနိုင်ငံတော်အစိုးရ</h1>
              <h2 className="text-md font-bold">ပြည်ထောင်စုရှေ့နေချုပ်ရုံး</h2>
              <div className="flex justify-center items-center gap-2">
                <DatalistInput
                  name="office"
                  value={formData.office || ""}
                  onChange={handleChange}
                  placeholder=""
                  options={OFFICE_OPTIONS}
                />
                <span className="w-12 text-left font-bold">ရုံး</span>
              </div>
            </div>
    
            {/* Meta Section (Letter No & Date Lines) */}
            <div className="flex flex-col items-end space-y-2 mt-6">
              <div className="flex items-center gap-1 w-64 justify-end">
                <span className="whitespace-nowrap">စာအမှတ်၊</span>
                <input 
                  type="text" 
                  name="letterNo"
                  value={formData.letterNo}
                  onChange={handleChange}
                  className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center"
                />
              </div>
    
              <div className="flex items-center gap-1 w-72 justify-end text-sm">
                <span className="whitespace-nowrap">ရက်စွဲ၊ ၂၀</span>
                <input 
                  type="text" 
                  name="year"
                  value={formData.year}
                  onChange={handleChange}
                  className="w-8 bg-transparent border-b border-dotted border-black focus:outline-none text-center"
                  placeholder=""
                />
                <span>ခုနှစ်၊</span>
                <input 
                  type="text" 
                  name="month"
                  value={formData.month}
                  onChange={handleChange}
                  className="w-16 bg-transparent border-b border-dotted border-black focus:outline-none text-center"
                />
                <span>လ၊</span>
                <input 
                  type="text" 
                  name="day"
                  value={formData.day}
                  onChange={handleChange}
                  className="w-8 bg-transparent border-b border-dotted border-black focus:outline-none text-center"
                />
                <span>ရက်</span>
              </div>
            </div>
    
            {/* Main Subject & Reference Grid */}
            <div className="mt-8 space-y-4">
              <div className="flex items-start">
                <span className="font-bold w-32 whitespace-nowrap">အကြောင်းအရာ။</span>
                <p className="font-bold flex-1 text-justify">
                  သေဒဏ်ထိုက်သည့်ပြစ်မှုတွင် ဆင်းရဲနွမ်းပါးသော တရားခံအတွက် အစိုးရစရိတ်ဖြင့် ရှေ့နေငှားရမ်းလိုက်ပါခွင့်ပြုခြင်း။
                </p>
              </div>
    
              <div className="flex items-start">
                <span className="font-bold w-32 whitespace-nowrap">ရည်ညွှန်းချက်။</span>
                <div className="flex-1 flex flex-wrap items-center text-justify leading-8">
                  <input 
                    type="text" 
                    name="refCourt" 
                    value={formData.refCourt} 
                    onChange={handleChange} 
                    className="w-48 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1"
                    placeholder=""
                  />
                  တရားရုံး၏
                 <div className="flex-grow">{renderDatePicker('date')}</div>
                  ရက်စွဲပါစာအမှတ်၊
                  <input 
                    type="text" 
                    name="refLetterNo" 
                    value={formData.refLetterNo} 
                    onChange={handleChange} 
                    className="w-36 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
    
            {/* Paragraph Content Box */}
            <div className="mt-8 text-justify leading-9 pl-4">
              <input 
                type="text" 
                name="caseTypeNo" 
                value={formData.caseTypeNo} 
                onChange={handleChange} 
                className="w-56 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1 font-bold"
                placeholder=""
              />
              တရားရုံး၊ ပြစ်မှုဆိုင်ရာ မူလမှု / အယူခံမှု / ပြင်ဆင်မှုအမှတ်
              <input 
                type="text" 
                name="complainant" 
                value={formData.complainant} 
                onChange={handleChange} 
                className="w-40 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1"
                placeholder=""
              />
              ၊ တရားလို / အယူခံတရားလို / လျှောက်ထားသူ
              <input 
                type="text" 
                name="plaintiff" 
                value={formData.plaintiff} 
                onChange={handleChange} 
                className="w-40 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1"
                placeholder=""
              /> 
              နှင့် တရားခံ / အယူခံတရားခံ / လျှောက်ထားခံရသူ
              <input 
                type="text" 
                name="accused" 
                value={formData.accused} 
                onChange={handleChange} 
                className="w-40 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1"
                placeholder=""
              />
              ၊
              <input 
                type="text" 
                name="law" 
                value={formData.law} 
                onChange={handleChange} 
                className="w-40 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1"
                placeholder=""
              />ဥပဒေ၊ ပုဒ်မ
              <input 
                type="text" 
                name="lawSection" 
                value={formData.lawSection} 
                onChange={handleChange} 
                className="w-36 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1"
                placeholder=""
              />
              အရ စွဲဆိုသည့်အမှု / ပြစ်ဒဏ်ချမှတ်သည့်အမှုတွင် တရားခံ
              <input 
                type="text" 
                name="accused" 
                value={formData.accused}
                disabled
                className="w-40 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1 bg-gray-50 text-gray-700"
              />
              အတွက် တရားလွှတ်တော် / အထက်တန်းရှေ့နေ ဦး / ဒေါ်
              <input 
                type="text" 
                name="advocateName" 
                value={formData.advocateName} 
                onChange={handleChange} 
                className="w-44 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1 font-bold"
                placeholder=""
              />
              (စဉ်-
              <input 
                type="text" 
                name="serialNo" 
                value={formData.serialNo} 
                onChange={handleChange} 
                className="w-16 text-center bg-transparent border-b border-dotted border-black focus:outline-none mx-1"
                placeholder=""
              />
              ) အား အစိုးရစရိတ်ဖြင့် ငှားရမ်းလိုက်ပါဆောင်ရွက်ခွင့်ပြုကြောင်း အကြောင်းကြားပါသည်။
            </div>
    
            {/* Main Signature Section */}
            <div className="mt-12 pr-6 flex flex-col items-end space-y-3">
              <div className="w-64 space-y-3">
                <div className="flex items-center">
                  <span className="w-24 text-right text-sm mr-2 whitespace-nowrap">လက်မှတ်</span>
                  <div 
                    onClick={() => setIsSigning(true)}
                    className="flex-1 bg-transparent border-b border-dotted border-black min-h-[32px] flex items-center justify-center cursor-pointer hover:bg-gray-50 transition relative group"
                  >
                    {formData.signatureImage ? (
                      <>
                        <img 
                          src={formData.signatureImage} 
                          alt="Signature" 
                          className="h-8 object-contain mix-blend-multiply" 
                        />
                        <span className="absolute inset-0 bg-black/40 text-white text-[10px] opacity-0 group-hover:opacity-100 flex items-center justify-center transition rounded">
                          ပြင်ဆင်ရန်
                        </span>
                      </>
                    ) : (
                      <span className="text-gray-400 text-xs font-sans">✍️ နှိပ်၍လက်မှတ်ထိုးရန်</span>
                    )}
                    {/* {formData.signatureImage && (
                      <button
                        type="button"
                        onClick={handleClearSignature}
                        title="လက်မှတ်ရှင်းလင်းမည်"
                        className="absolute -right-6 text-slate-400 hover:text-rose-500 text-xs px-1 font-bold z-10 print:hidden"
                      >
                        ✕
                      </button>
                    )} */}
                  </div>
                </div>
    
                <div className="flex items-center">
                  <span className="w-24 text-right text-sm mr-2 whitespace-nowrap">အမည်</span>
                  <input
                    type="text"
                    name="officerSignName"
                    value={formData.officerSignName}
                    onChange={handleChange}
                    className="flex-1 bg-transparent border-b border-dotted border-black focus:outline-none text-center text-xs"
                  />
                </div>
    
                <div className="text-center text-sm font-bold py-1">
                  တာဝန်ခံဥပဒေအရာရှိ
                </div>
              </div>
            </div>
    
            {/* CC Section (မိတ္တူကို-) */}
            <div className="mt-10 border-t border-gray-200 pt-6 space-y-3 text-sm">
              <div className="flex items-center gap-1">
                <span className="font-bold">ဦး / ဒေါ်</span>
                <input 
                  type="text" 
                  name="ccRecipientName" 
                  value={formData.ccRecipientName} 
                  onChange={handleChange} 
                  className="w-44 text-center bg-transparent border-b border-dotted border-black focus:outline-none"
                  placeholder=""
                />
                <span>(စဉ်-</span>
                <input 
                  type="text" 
                  name="ccRecipientSerial" 
                  value={formData.ccRecipientSerial} 
                  onChange={handleChange} 
                  className="w-16 text-center bg-transparent border-b border-dotted border-black focus:outline-none"
                  placeholder=""
                />
                <span>)</span>
              </div>
    
              <div className="pl-14 flex items-center gap-2">
                <DatalistInput
                  name="ccTownship"
                  value={formData.ccTownship}
                  onChange={handleChange}
                  placeholder=""
                  options={TOWNSHIP_OPTIONS}
                  className="w-40 text-center bg-transparent border-b border-black focus:outline-none"
                />
                <span className="font-bold">မြို့။</span>
              </div>
    
              <div className="font-bold pt-2">မိတ္တူကို -</div>
              
              <div className="pl-6 space-y-2 text-justify leading-7">
                <div className="flex items-center gap-1 flex-wrap">
                  <input 
                    type="text" 
                    name="ccJudge" 
                    value={formData.ccJudge} 
                    onChange={handleChange} 
                    className="w-48 text-center bg-transparent border-b border-dotted border-black focus:outline-none text-xs"
                    placeholder=""
                  />
                  <span>တရားသူကြီး၊</span>
                  
                  
                </div>

                <div className="flex items-center gap-1 flex-wrap">
                  <input 
                    type="text" 
                    name="ccJudgeCourt" 
                    value={formData.ccJudgeCourt} 
                    onChange={handleChange} 
                    className="w-48 text-center bg-transparent border-b border-dotted border-black focus:outline-none text-xs"
                    placeholder=""
                  />
                  <span>တရားရုံး။</span>
                  
                  
                </div>
                
                <div className="flex items-center gap-1 flex-wrap">
                  <DatalistInput
                    name="ccTownshipJudge"
                    value={formData.ccTownshipJudge}
                    onChange={handleChange}
                    placeholder=""
                    options={TOWNSHIP_OPTIONS}
                    className="w-36 text-center bg-transparent border-b border-black focus:outline-none text-xs"
                  />
                  <span>မြို့။</span>
                </div>
              </div>
            </div>  
            {/* <div className="absolute bottom-4 left-4 text-xs text-gray-400 print:bottom-0 print:left-0">
              လျှို့ဝှက်
            </div> */}

    
          </div>
  );
};